import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'rcm-container',
  styleUrl: 'rcm-container.scss',
  shadow: false,
})
export class RcmContainer {
  /** Make the component visible on stories - **For development use only** */
  @Prop() public debug = false;

  /** Should the container be full width */
  @Prop() public fullWidth = false;

  /** Should the container be full width for mobile */
  @Prop() public fullWidthMobile = false;

  @Element() private element: HTMLRcmContainerElement;

  public componentWillRender(): void {
    const containerClasses = {
      container: true,
      'container--full-width': this.fullWidth,
      'container--full-width-mobile': this.fullWidthMobile,
      'container--debug': this.debug,
    };

    // This is only needed due to the grid-system using Bulma under-the-hood
    Object.keys(containerClasses).forEach((item) => {
      this.element.classList[containerClasses[item] ? 'add' : 'remove'](item);
    });
  }

  public render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
